module.exports = __webpack_public_path__ + "img/6.26dc4aca.png";